/**
 * @module mapbs.components.copytoclip.copytoclipservice
 */

import angular from 'angular';

const moduleCopyclipservice = angular.module('mapbsCopyToClipServiceModule', []);

class CopyToClipService {
    getCopyToClipService(toCopy, element) {
        element.val(toCopy);

        element[0].select();

        const successful = document.execCommand('copy');
        if (!successful) {
            throw successful;
        }
    }
}

moduleCopyclipservice.service('mapbsCopyToClipService', CopyToClipService);

export default moduleCopyclipservice;
